import styled, { css } from 'styled-components'

const scroll = css``

export const Table = styled.div`
  display: grid;
  grid-template-columns: ${({ gridTemplate }) =>
    gridTemplate ? gridTemplate : '.25fr 1fr .75fr 1fr 1fr 1fr 1fr 1.5fr 1fr .50fr 1fr'};
  overflow-y: auto;
  width: 100%;

  ${scroll}
`
